import { useAtomValue } from 'jotai';
import { featuresAtom } from '../atoms';
import type { ReviewFeaturesT } from '../types';
export const useReviewFeature = (): ReviewFeaturesT => {
  const features = useAtomValue(featuresAtom);
  return features;
};